(function () {
  const settings = window.themeSettings || {};
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const level = prefersReduced ? 'none' : (settings.animationIntensity || 'full');
  const disableAllMotion = level === 'none';
  const reduceMotion = level === 'reduced' || disableAllMotion;

  document.body.classList.add('is-loaded');

  const progressBar = document.querySelector('.scroll-progress-bar');
  const parallaxNodes = reduceMotion
    ? []
    : Array.from(document.querySelectorAll('[data-parallax-speed]'));

  function updateProgress() {
    if (!progressBar) return;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const progress = maxScroll > 0 ? (window.scrollY / maxScroll) * 100 : 0;
    progressBar.style.width = `${progress}%`;
  }

  function setupRevealObserver() {
    const targets = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-down, .stagger-children');
    if (!targets.length) return;

    if (disableAllMotion) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, observerRef) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        if (entry.target.classList.contains('stagger-children')) {
          const delay = entry.target.dataset.stagger || '100';
          Array.from(entry.target.children).forEach((child, index) => {
            child.style.setProperty('--stagger-step', `${delay}ms`);
            child.style.setProperty('--stagger-index', `${index}`);
          });
        }
        observerRef.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

    targets.forEach((target) => observer.observe(target));
  }

  function setupParallax() {
    if (!parallaxNodes.length) {
      updateProgress();
      return;
    }

    let ticking = false;

    function renderParallax() {
      const scrollY = window.scrollY;
      parallaxNodes.forEach((node) => {
        const baseSpeed = Number(node.dataset.parallaxSpeed || 0);
        const multiplier = level === 'reduced' ? 0.35 : 1;
        const translate = scrollY * baseSpeed * multiplier;
        node.style.transform = `translate3d(0, ${translate}px, 0)`;
      });
      updateProgress();
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(renderParallax);
    }, { passive: true });

    renderParallax();
  }

  function setupCursor() {
    if (reduceMotion || !window.matchMedia('(pointer: fine)').matches) return;

    const cursor = document.createElement('div');
    cursor.className = 'custom-cursor';
    document.body.appendChild(cursor);

    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let currentX = targetX;
    let currentY = targetY;

    document.addEventListener('mousemove', (event) => {
      targetX = event.clientX;
      targetY = event.clientY;

      const isInteractive = event.target.closest('a, button, input, label, [role="button"], .product-card');
      cursor.classList.toggle('is-hovering', Boolean(isInteractive));
    });

    function render() {
      currentX += (targetX - currentX) * 0.16;
      currentY += (targetY - currentY) * 0.16;
      cursor.style.left = `${currentX}px`;
      cursor.style.top = `${currentY}px`;
      requestAnimationFrame(render);
    }

    requestAnimationFrame(render);
  }

  function setupParticles() {
    if (reduceMotion) return;

    document.querySelectorAll('[data-particle-field]').forEach((field) => {
      const count = level === 'reduced' ? 4 : 7;

      for (let index = 0; index < count; index += 1) {
        const particle = document.createElement('span');
        particle.className = 'particle';
        particle.style.setProperty('--x', `${10 + Math.random() * 80}%`);
        particle.style.setProperty('--size', `${4 + Math.random() * 5}px`);
        particle.style.setProperty('--duration', `${8 + Math.random() * 8}s`);
        particle.style.setProperty('--delay', `${Math.random() * 6}s`);
        particle.style.setProperty('--drift', `${(Math.random() * 80) - 40}px`);
        field.appendChild(particle);
      }
    });
  }

  setupRevealObserver();
  setupParallax();
  setupCursor();
  setupParticles();
  updateProgress();

  // Re-observe elements after Shopify customizer section updates
  document.addEventListener('shopify:section:load', () => {
    setupRevealObserver();
  });
})();
